import { ParamMap } from '@angular/router';

import { AirSearchPayload } from '@flight-results/entities/airSearchPayload';

export function bySectorIsEnabled(
  params: AirSearchPayload,
  isAnInternationalTrip: boolean,
  treatment: boolean,
  isMobile: boolean,
  isExchangeSearch: boolean = false,
  queryParams: ParamMap
): boolean {
  const flights = params?.Trips?.length;
  const isRoundTrip = flights > 1;
  const depatureDate = flights ? params?.Trips?.[0].DepartureDate : null;
  const arrivalDate = flights ? params?.Trips?.[flights - 1].DepartureDate : null;
  const validByDates = isRoundTrip ? !!depatureDate && !!arrivalDate && depatureDate !== arrivalDate : true;
  
  return !isAnInternationalTrip && treatment && !!validByDates && !isExchangeSearch 
    && isMobile && !queryParams?.get('flight_key');
}

export function getSearchFlowType(treatment: boolean): string {
  return treatment ? 'BySector' : 'Traditional';
}

export function getTravelSegment(treatment: boolean, sectors: number[]): string {
  return treatment ? (sectors?.length > 0 ? 'Inbound' : 'Outbound') : undefined;
}
